import 'css-chunksrc/client/pages/workloadPage/toolbar/yearNavigation/years/styles.scss';export default {
  "calendar": "_calendar_2zknx_1",
  "heading": "_heading_2zknx_7",
  "title": "_title_2zknx_18",
  "iconBox": "_iconBox_2zknx_27",
  "icon": "_icon_2zknx_27",
  "rightIcon": "_rightIcon_2zknx_48",
  "leftIcon": "_leftIcon_2zknx_52",
  "main": "_main_2zknx_56",
  "years": "_years_2zknx_60",
  "row": "_row_2zknx_65",
  "year": "_year_2zknx_60",
  "selected": "_selected_2zknx_92"
};